export const MY_ACTIONS_LABELS = {
  actionPlan: 'ACTION PLAN',
  selfAssessment: 'SELF ASSESSMENT',
  myAudit: 'myAUDIT',
};

export const MY_ACTION_LABELS_LOWER_CASE = {
  actionPlan: 'Action Plan',
  selfAssessment: 'Self Assessment',
  myAudit: 'myAudit',
};
